import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { AUTH } from "../constants/testIds";
import { Factory, Lock } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    const res = await login(email.trim().toLowerCase(), password);
    setBusy(false);
    if (!res.ok) setErr(res.error);
    else nav("/", { replace: true });
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-slate-50">
      <div className="hidden lg:flex relative flex-col justify-between p-12 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(rgba(255,255,255,.15) 1px, transparent 1px)", backgroundSize: "16px 16px" }} />
        <div className="relative flex items-center gap-2">
          <Factory className="h-6 w-6 text-blue-400" />
          <span className="font-display font-extrabold text-xl tracking-tight">ATÖLYE ERP</span>
        </div>
        <div className="relative">
          <p className="text-xs uppercase tracking-widest text-blue-300 mb-3">Sipariş & Üretim Takibi</p>
          <h1 className="font-display text-5xl font-extrabold leading-tight mb-4">
            Her sipariş, her aşama<br/>tek panelde.
          </h1>
          <p className="text-slate-300 max-w-md">
            İnternet satışlarınızı, imalat sürecinizi ve stok hareketlerinizi tek bir sistemde yönetin. Aşamaları ihtiyaçlarınıza göre özelleştirin.
          </p>
        </div>
        <div className="relative text-xs text-slate-400 font-mono">v1.0 · Modüler ERP</div>
      </div>
      <div className="flex items-center justify-center p-6 lg:p-12">
        <form onSubmit={submit} className="w-full max-w-md bg-white border border-slate-200 rounded-xl shadow-sm p-8">
          <div className="flex items-center gap-2 mb-1"><Lock className="h-4 w-4 text-blue-600" /><span className="text-xs uppercase tracking-widest text-slate-500 font-bold">Giriş</span></div>
          <h2 className="font-display text-3xl font-extrabold text-slate-900 mb-1">Hoş geldiniz</h2>
          <p className="text-sm text-slate-500 mb-6">Hesabınıza giriş yaparak devam edin.</p>

          <div className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-widest text-slate-600 font-bold">E-posta</Label>
              <Input data-testid={AUTH.emailInput} value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="ornek@firma.com" className="mt-1" required />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest text-slate-600 font-bold">Şifre</Label>
              <Input data-testid={AUTH.passwordInput} value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="••••••••" className="mt-1" required />
            </div>
            {err && <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{err}</div>}
            <Button data-testid={AUTH.submitBtn} type="submit" disabled={busy} className="w-full bg-blue-600 hover:bg-blue-700 text-white transition-colors">
              {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
